import moment from 'moment'
import { SkudReportEndpoint } from '@/views/skud/shared/endpoint_services/skud-report-endpoint-service'

const DT = 'DD.MM.YYYY HH:mm:ss'
const D = 'DD.MM.YYYY'

function dt (v) {
  return v ? moment(v).format(DT) : v
}

function d (v) {
  return v ? moment(v).format(D) : v
}

// Дата «по» из фильтра — без времени, включаем весь день.
function eod (params) {
  const p = Object.assign({}, params)
  if (p.to && p.to.length === 10) p.to += 'T23:59:59'
  return p
}

export class SkudReportService {
  constructor () {
    this.endpoint = new SkudReportEndpoint()
  }

  // -> {by_day[], by_group[], top_subjects[]} или {} при ошибке
  async getLatecomers (placeId, params) {
    const data = await this.endpoint.getLatecomers(placeId, eod(params))
    if (!data) return {}
    return {
      by_day: (data.by_day || []).map(i => ({ ...i, date: d(i.date) })),
      by_group: data.by_group || [],
      top_subjects: data.top_subjects || []
    }
  }

  // -> {items[]} или {} при ошибке
  async getEarlyLeavers (placeId, params) {
    const data = await this.endpoint.getEarlyLeavers(placeId, eod(params))
    if (!data) return {}
    return {
      items: (data.items || []).map(i => ({ ...i, occurred_at: dt(i.occurred_at) }))
    }
  }

  // -> {items[]} или {} при ошибке; screen — сырая строка терминала, не enum
  async getSuspicious (placeId, params) {
    const data = await this.endpoint.getSuspicious(placeId, eod(params))
    if (!data) return {}
    return {
      items: (data.items || []).map(i => ({ ...i, occurred_at: dt(i.occurred_at) }))
    }
  }
}
